<main class="text-center">
  <div class="bloco-central pt-5 mt-5">
    <!-- For Component View -->
    <img src="assets/logo_icone.png" class="v-logo" alt="">
    <h1>Legis</h1>
    <img src="assets/zoom-logo.png" class="z-logo mt-4" alt="">
    <button #btnZoom (click)="startMeeting(jsonObject);">Iniciando a aplicação ...</button>
  </div>
</main>
